"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.untypedResolvedExpressionSchema = exports.expressionSchema = exports.refExpressionSchema = exports.SortDirection = exports.ResolvedExpressionType = void 0;
var jsonschema_1 = require("../utils/jsonschema");
// enums
var ResolvedExpressionType;
(function (ResolvedExpressionType) {
    ResolvedExpressionType["Join"] = "JOIN";
    ResolvedExpressionType["Split"] = "SPLIT";
    ResolvedExpressionType["Sum"] = "SUM";
    ResolvedExpressionType["Product"] = "PRODUCT";
    ResolvedExpressionType["Inverse"] = "INVERSE";
    ResolvedExpressionType["Or"] = "OR";
    ResolvedExpressionType["And"] = "AND";
    ResolvedExpressionType["Not"] = "NOT";
    ResolvedExpressionType["Equal"] = "EQUAL";
    ResolvedExpressionType["Sorted"] = "SORTED";
    ResolvedExpressionType["Sort"] = "SORT";
    ResolvedExpressionType["Concat"] = "CONCAT";
    ResolvedExpressionType["Merge"] = "MERGE";
    ResolvedExpressionType["Find"] = "FIND";
    ResolvedExpressionType["Entries"] = "ENTRIES";
    ResolvedExpressionType["FunctionDeclaration"] = "FUNCTION";
    ResolvedExpressionType["ExternalFunction"] = "EXTERNAL_FUNCTION";
    ResolvedExpressionType["Variable"] = "VARIABLE";
    ResolvedExpressionType["FunctionCall"] = "FUNCTION_CALL";
})(ResolvedExpressionType = exports.ResolvedExpressionType || (exports.ResolvedExpressionType = {}));
var SortDirection;
(function (SortDirection) {
    SortDirection["Ascending"] = "ASCENDING";
    SortDirection["Descending"] = "DESCENDING";
})(SortDirection = exports.SortDirection || (exports.SortDirection = {}));
exports.refExpressionSchema = {
    $id: jsonschema_1.$id('refExpression'),
    title: 'Reference',
    type: 'object',
    properties: {
        $ref: {
            type: 'string'
        }
    },
    required: ['$ref'],
    additionalProperties: false
};
exports.expressionSchema = {
    $id: jsonschema_1.$id('expression'),
    title: 'Expression',
    anyOf: [
        { $ref: jsonschema_1.$id('stringExpression') },
        { $ref: jsonschema_1.$id('numberExpression') },
        { $ref: jsonschema_1.$id('booleanExpression') },
        { $ref: jsonschema_1.$id('arrayExpression') },
        { $ref: jsonschema_1.$id('objectExpression') },
        { $ref: jsonschema_1.$id('functionExpression') },
        { $ref: jsonschema_1.$id('variableExpression') },
        { $ref: jsonschema_1.$id('functionCallExpression') },
        { $ref: jsonschema_1.$id('findExpression') },
        { $ref: jsonschema_1.$id('refExpression') }
    ]
};
exports.untypedResolvedExpressionSchema = {
    $id: jsonschema_1.$id('untypedResolvedExpression'),
    title: 'Untyped expression',
    anyOf: [
        { $ref: jsonschema_1.$id('variableExpression') },
        { $ref: jsonschema_1.$id('functionCallExpression') },
        { $ref: jsonschema_1.$id('refExpression') }
    ]
};
//# sourceMappingURL=expressions.js.map